// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3hNg8","containerItemsCenter":"Skeleton_containerItemsCenter__1DFiv"};